import type { ActionConfig } from "@smartsuite/automation-engine-api";
import { useRootStore } from "../stores/hooks";
import { actionSolutionId } from "../utils/action-solutions";
import type { MemberScope } from "../utils/member-scope";
import {
  solutionMemberScope,
  workspaceMemberScope,
} from "../utils/member-scope";

/**
 * Members and teams selectable on a field of `action` -- i.e. those with access
 * to the solution that action writes into, which is not necessarily the solution
 * hosting the automation. Pass `undefined` for trigger inputs.
 */
export const useActionMemberDirectory = (
  action?: ActionConfig,
): MemberScope => {
  const store = useRootStore();

  return solutionMemberScope(
    store,
    actionSolutionId(action, store.config.solutionId),
  );
};

/** Members and teams selectable as notification recipients. */
export const useWorkspaceMemberDirectory = (): MemberScope => {
  const store = useRootStore();

  return workspaceMemberScope(store);
};
